export default {
	ARQUIVO: {
		ENVIAR_ARQUIVO_TEMPORARIO: 'enviarArquivoTemporario',
		BAIXAR_ARQUIVO_TEMPORARIO: 'baixarArquivoTemporario',
		EXCLUIR_ARQUIVO_TEMPORARIO: 'excluirArquivoTemporario',
	},
	COMUM: {
		ATUALIZAR_SESSAO: 'atualizarSessao',
		BUSCAR_LINK_EDITAR_USUARIO: 'buscarLinkEditarUsuario',
		BUSCAR_PRODUTO_POR_NOME: 'buscarProdutoPorNome',
		BUSCAR_USUARIO_LOGADO: 'buscarUsuarioLogado',
		BUSCAR_INFORMACOES_USUARIO: 'buscarInformacoesUsuario',
		BUSCAR_PARAMETROS_SISTEMA: 'buscarParametrosDoSistema',
	},
	DOCUMENTOS: {
		BUSCA_PAGINADA_GENERICA: 'buscaPaginadaDocumentosGenerica',
		EXCLUIR_DOCUMENTO_GENERICO: 'excluirDocumentoOuAnexoGenerico',
		BAIXAR_DOCUMENTO_GENERICO: 'baixarDocumentoOuAnexoGenerico',
		CANCELAR_DOCUMENTO_GENERICO: 'cancelarDocumentoGenerico',
		EDITOR_TEXTO: {
			INSERIR_GENERICO: 'inserirDocumentoEditorTextoGenerico',
			REDIGIR_GENERICO: 'redigirDocumentoEditorTextoGenerico',
			VISUALIZA_GENERICO: 'visualizarDocumentoEditorTextoGenerico',
			CONCLUIR_DOCUMENTO_GENERICO: 'concluirDocumentoEditorTextoGenerico',
			BUSCAR_POR_ID: 'buscarDocumentoEditorTextoPorIdGenerico',
			SINCRONIZAR: 'sincronizarDocumentoEditorTextoGenerico',
		},
		ANEXO: {
			INSERIR_GENERICO: 'inserirAnexoGenerico',
		},
		PNCP: {
			ENVIAR_DOCUMENTO_GENERICO: 'enviarDocumentoPncpGenerico',
			EXCLUIR_DOCUMENTO_GENERICO: 'excluirDocumentoPncpGenerico',
		},
		PROCESSO_DIGITAL: {
			ASSINAR_ELETRONICAMENTE: 'documentosAssinarEletronicamenteGenerico',
			ASSINAR_DIGITALMENTE: 'documentosAssinarDigitalmenteGenerico',
			VALIDAR_DOCUMENTO_ASSINADO: 'documentosValidarAssinaturaGenerico',
			JUNTAR_LOTE_DOCUMENTOS: 'documentoJuntarLoteGenerico',
			BUSCAR_DOCUMENTO_POR_ID: 'buscarDocumentoPorIdGenerico',
			DESENTRANHAMENTO: {
				CRIAR_TERMO: 'criarTermoGenerico',
				JUNTAR_TERMO: 'juntarTermoGenerico',
			},
		},
		SIGNATARIOS: {
			BUSCAR_SIGNATARIOS: 'documentosBuscarSignatariosGenerico',
			EXCLUIR: 'documentosExcluirSignatariosGenerico',
			CONVIDAR_SIGNATARIOS: 'documentosConvidarSignatariosGenerico',
		},
	},
	GERAR_RELATORIO: {
		BAIXAR_RELATORIO: 'baixarRelatorio',
	},
	FLOWBEE: {
		BUSCAR_CONFIGURACOES: 'flowbeeBuscarConfiguracao',
	},
	COMPRAS_LEGADO: {
		BUSCAR_URL_ATA_RP: 'buscarUrlAtaRp',
	},
	CONFIGURACAO: {
		MODELO_DOCUMENTO: {
			BUSCAR_MODELOS_DOCUMENTOS: 'buscarModelosDocumentos',
			CRIAR_MODELO_DOCUMENTO: 'salvarModeloDocumento',
			BUSCAR_MODELOS_DOCUMENTOS_ATIVOS: 'buscarModelosDocumentosAtivos',
			VISUALIZAR_MODELOS_DOCUMENTOS: 'visualizarModelosDocumentos',
			BUSCAR_MODELO: 'buscarModeloDocumentoPorId',
			EDITAR_MODELO: 'salvarEdicaoModeloDocumento',
			REDIGIR_MODELOS_DOCUMENTOS: 'redigirModelosDocumentos',
			EXCLUIR_MODELO: 'excluirModeloDocumento',
		},
		TIPO_MODELO_DOCUMENTO: {
			BUSCAR_TIPOS_MODELO_DOCUMENTOS_ATIVOS: 'buscarTiposModeloDocumentos',
			BUSCAR_TIPOS_MODELO_DOCUMENTO_LISTAGEM_PAGINADA: 'buscarTiposModeloDocumentosPaginado',
			CRIAR_TIPO_DOCUMENTO: 'criarTipoDocumento',
			EXCLUIR_TIPO_DOCUMENTO: 'excluirTipoDocumento',
			EDITAR_TIPO_DOCUMENTO: 'editarTipoDocumento',
			BUSCAR_VALIDACOES_TRAMITACAO: 'buscarValidacoesTramitacaoTipoDocumento',
			CRIAR_VALIDACAO_TRAMITACAO: 'criarValidacaoTramitacaoTipoDocumento',
			EDITAR_VALIDACAO_TRAMITACAO: 'editarValidacaoTramitacaoTipoDocumento',
			EXCLUIR_VALIDACAO_TRAMITACAO: 'excluirValidacaoTramitacaoTipoDocumento',
		},
		FISCAIS: {
			BUSCAR_FISCAIS: 'buscarFiscais',
			EXCLUIR_FISCAL: 'excluirFiscal',
			BUSCAR_ORGAOS: 'buscarOrgaosModalAdicionarFiscal',
			BUSCAR_USUARIOS_FISCAIS: 'buscarUsuariosFiscais',
			ADICIONAR_FISCAL: 'adicionarFiscal',
			BUSCAR_ANEXOS: 'buscarAnexos',
			BAIXAR_ANEXO: 'baixarAnexo',
			EDITAR_FISCAL: 'editarFiscal',
			EXCLUIR_ANEXO_FISCAL: 'excluirAnexoFiscal',
		},
		REVISOES: {
			BUSCAR_REVISOES: 'buscarRevisoes',
			EXCLUIR_REVISAO: 'excluirRevisao',
			INSERIR_REVISAO: 'inserirRevisao',
			BUSCAR_REVISAO_POR_ID: 'buscarRevisaoPorId',
			EDITAR_REVISAO: 'editarRevisao',
			ALTERAR_SITUACAO_REVISAO: 'alterarSituacaoRevisao',
			MODELO_DOCUMENTO: {
				SALVAR_MODELO_DOCUMENTO_REVISAO: 'salvarModeloDocumentoRevisao',
				REMOVER_MODELO_DOCUMENTO_REVISAO: 'removerModeloDocumentoRevisao',
				REDIGIR_MODELO_DOCUMENTO_REVISAO: 'redigirModeloDocumentoRevisao',
				VISUALIZAR_MODELO_DOCUMENTO_REVISAO: 'visualizarModeloDocumentoRevisao',
			},
		},
	},
	RELATORIOS: {
		CONTROLE_SALDOS: {
			BUSCAR_ATAS: 'buscarAtasControleSaldos',
			BUSCAR_ORGAOS: 'buscarOrgaosControleSaldos',
			GERAR_RELATORIO: 'gerarRelatorioControleSaldos',
		},
		CONTROLE_ADESOES: {
			BUSCAR_ATAS: 'buscarAtasControleAdesoes',
			GERAR_RELATORIO: 'gerarRelatorioControleAdesoes',
		},
		PAINEL: {
			BUSCAR_LISTAGEM: 'RelatoriosPainelBuscarListagem',
		},
	},
	PROCESSO: {
		BUSCAR_POR_ID: 'buscarProcessoPorId',
		BUSCAR_PROCESSOS_LISTAGEM: 'buscarProcessosListagem',
		BUSCAR_ORGAOS_USUARIO_FILTRO: 'buscarOrgaosUsuarioFiltro',
		BUSCAR_ORGAOS_QUANTIFICARAM_NO_PROCESSO: 'buscarOrgaosQuantificaramNoProcesso',
	},
	ITEM_PROCESSO: {
		BUSCAR_ITENS_PROCESSOS_LISTAGEM: 'buscarItensProcessosListagem',
		BUSCAR_ITENS_PROCESSOS_POR_FORNECEDOR: 'buscarItensProcessosPorFornecedor',
		EDITAL: {
			BUSCAR_EDITAIS_POR_FILTRO: 'buscarEditalPorFiltro',
		},
	},
	FORNECEDOR: {
		BUSCAR_FORNECEDORES_POR_FILTRO: 'buscarFornecedoresPorFiltro',
	},
	TIPO: {
		BUSCAR_TIPOS_POR_PROCESSO: 'buscarTiposPorProcesso',

		POR_NUMERO_E_ITEM_PROCESSO: {
			BUSCAR_TIPOS_POR_NUMERO_E_PROCESSO: 'buscarTiposPorNumeroEProcesso',
		},
	},
	PROCESSO_UTILIZACAO: {
		BUSCAR_POR_FILTRO: 'buscarProcessosUtilizacaoPorFiltro',
		BUSCAR_URL_PROCESSO_UTILIZACAO_LEGADO: 'BuscarUrlProcessoUtilizacaoLegado',
		BUSCAR_ORGAOS: 'buscarOrgaosProcessoUtilizacao',
	},
	ATA: {
		BUSCAR_DATA_PRORROGACAO: 'buscarDataProrrogacao',
		BUSCAR_POR_ID: 'buscarAtaPorId',
		BUSCAR_POR_FILTRO: 'buscarAtasPorFiltro',
		BUSCAR_ATIVIDADES_FILTRO: 'buscarAtividadesFiltro',
		INSERIR_POR_PROCESSO: 'inserirPorProcesso',
		ATUALIZAR_ATA_COM_PROCESSO: 'atualizarAtaComProcesso',
		BLOQUEAR_ATA: 'bloquearAta',
		DESBLOQUEAR_ATA: 'desbloquearAta',
		CANCELAR_ATA: 'cancelarAta',
		EXCLUIR: 'excluirAta',
		SALVAR_NUMERO_ATA: 'salvarNumeroAta',
		EFETIVAR_ATA: 'efetivarAta',
		IMPORTAR_CONSUMO: 'importarConsumoAta',
		BUSCAR_ATAS_COLLAPSES_ADESOES: 'buscarAtasCollapsesAdesoes',
		BAIXAR_MODELO_IMPORTAR_PREV_CONSUMO: 'baixarModeloImportarPrevConsumoAta',
		VERIFICAR_PLANILHA_IMPORTADA_PARA_ORGAO: 'verificarPlanilhaImportadaParaOrgao',
		GERAR_MODELO_IMPORTAR_PREV_CONSUMO: 'gerarModeloImportarPrevConsumoAta',
		ENVIAR_ATA_PARA_PNCP: 'enviarAtaParaPncp',
		EXCLUIR_ATA_NO_PNCP: 'excluirAtaNoPncp',
		REENVIAR_ATA_PARA_DETALHAMENTO: 'reenviarAtaParaDetalhamento',
		PRORROGAR_ATA: 'prorrogarAta',
		BUSCAR_ORGAOS_FILTRO: 'buscarOrgaosAtaFiltro',
		BUSCAR_CONTRATADOS: 'buscarContratadosAta',
		BUSCAR_ORGAOS_PARTICIPANTES: 'buscarOrgaosParticipantesAta',
		DOCUMENTOS_ATA: {
			ANEXOS: {
				CRIAR: 'documentosAtaEditorAnexosCriar',
			},
			DOCUMENTOS: {
				EDITOR_TEXTO: {
					ADICIONAR: 'documentosAtaEditorAdicionarDocumento',
					REDIGIR: 'documentosAtaEditorTextoRedigir',
					SINCRONIZAR: 'documentosAtaEditorTextoSincronizar',
					VISUALIZAR: 'documentosAtaEditorTextoVisualizar',
					BUSCAR_POR_ID: 'buscarDocumentoEditorTextoPorId',
				},
				CONVIDAR_SIGNATARIOS: 'convidarSignatariosDocumentoAta',
				BUSCAR_SIGNATARIOS: 'buscarSignatariosDocumentoAta',
				BUSCAR_ASSINATURAS_NAO_CONCLUIDAS: 'buscarAssinaturasNaoConcluidasDocumentoAta',
				SIGNATARIOS: {
					BUSCAR_TODOS: 'buscarTodosSignatariosAta',
					EXCLUIR: 'excluirSignatariosAta',
				},
			},
			PROCESSO_DIGITAL: {
				JUNTAR_LOTE_DOCUMENTOS: 'documentosAtaJuntarLote',
				ASSINAR_DIGITALMENTE: 'documentosAtaAssinarDigitalmente',
				ASSINAR_ELETRONICAMENTE: 'documentosAtaAssinarEletronicamente',
				ASSINAR_ELETRONICAMENTE_LOTE: 'documentosAtaAssinarEletronicamenteLote',
				VALIDAR_DOCUMENTO_ASSINADO: 'documentosValidarAssinatura',
				BAIXAR_PARA_IMPRESSAO: 'baixarParaImpressao',
				VISUALIZAR_PROCESSO_DIGITAL: 'visualizarProcessoDigital',
				BUSCAR_DOCUMENTO_POR_ID: 'buscarDocumentoProcessoDigitalPorId',
				CANCELAR_DOCUMENTO: 'cancelarDocumentoAta',
				DESENTRANHAMENTO: {
					CRIAR_TERMO: 'criarTermo',
					JUNTAR_TERMO: 'juntarTermo',
				},
			},
			INSERIR: 'inserirDocumentoAta',
			BUSCAR_POR_FILTRO: 'buscarDocumentosPorFiltro',
			EXCLUIR_DOCUMENTO_OU_ANEXO: 'excluirDocumentoOuAnexoAta',
			BAIXAR_DOCUMENTO_ANEXO: 'documentosAnexosBaixar',
			ENVIAR_DOCUMENTO_PARA_PNCP: 'enviarDocumentoParaPncp',
			EXCLUIR_DOCUMENTO_NO_PNCP: 'excluirDocumentoNoPncp',
			ENVIAR_DOCUMENTO_PARA_FORNECEDOR: 'enviarDocumentoParaFornecedor',
			SINCRONIZAR_AREA_PUBLICA: 'sincronizarDocumentoAtaAreaPublica',
			SINCRONIZAR_AREA_PUBLICA_EM_LOTE: 'sincronizarDocumentoAtaAreaPublicaEmLote',
		},
		ACOMPANHAMENTO: {
			BUSCAR_POR_FILTRO: 'ataAcompanhamentoBuscarPorFiltro',
			BUSCAR_LISTAGEM_SALDO_ORGAO_POR_ITEM: 'ataAcompanhamentoBuscarListagemSaldoOrgaoPorItem',
			BUSCAR_LISTAGEM_DETALHES_SALDO_POR_ORGAO: 'ataAcompanhamentoBuscarListagemDetalhesSaldoPorOrgao',
		},
		GESTAO_PEDIDO: {
			NOVO_PEDIDO: 'criarNovoPedido',
			BUSCAR_LISTAGEM_PEDIDOS_COLLAPSE: 'buscarListagemPedidosCollapse',
			BUSCAR_LISTAGEM_PEDIDOS_POR_PROCESSO: 'buscarListagemPedidosPorProcessos',
		},
		GESTAO_ATA: {
			BUSCAR_LISTAGEM_HISTORICO_PRORROGACAO: 'buscarListagemHistoricoProrrogacao',
			EXCLUIR_PRORROGACAO: 'excluirProrrogacao',
			BUSCAR_ITENS_ATA_BOTAO_HISTORICO: 'buscarItensAtaBotaoHistorico',
		},
		FISCAIS: {
			BUSCAR_FISCAIS_LISTAGEM_MODAL: 'buscarFiscaisListagemModal',
			ADICIONAR_FISCAIS: 'adicionarFiscais',
			BUSCAR_FISCAIS_ATA: 'buscarFiscaisAta',
			EXCLUIR_FISCAL_ATA: 'excluirFiscalAta',
		},
		CONTROLE_SALDOS_ORGAO: {
			BUSCAR_ORGAOS_USUARIO: 'buscarOrgaosUsuario',
			BUSCAR_POR_FILTRO: 'buscarControleSaldosPorFiltro',
		},
		PARTES_ENVOLVIDAS: {
			BUSCAR_POR_FILTRO: 'buscarPartesEnvolvidasPorFiltro',
			CRIAR: 'criarParteEnvolvida',
			VALIDAR: 'validarParteEnvolvidaCadastrada',
		},
	},
	ITEM_ATA: {
		BUSCAR_ITENS_ATA_LISTAGEM: 'buscarItensAtaListagem',
		EXCLUIR: 'excluirItensAta',
		INSERIR_ITEM_ATA_COM_PROCESSO: 'inserirItemAtaComProcesso',

		REALINHAMENTO: {
			HISTORICO: {
				BUSCAR_HISTORICOS: 'buscarHistoricosRealinhamento',
			},
			REALINHAR: {
				INSERIR_REALINHAR_ATA: 'inserirRealinharAta',
			},
		},

		ADITAMENTO: {
			HISTORICO: {
				BUSCAR_HISTORICOS: 'buscarHistoricosAditamento',
			},
			ADITAR: {
				INSERIR_PERCENTUAL: 'inserirPercentual',
			},
		},

		ALTERAR_FORNECEDOR: {
			ALTERAR: {
				BUSCAR_FORNECEDORES: 'buscarFornecedores',
				BUSCAR_FILIAIS: 'buscarFiliais',
				INSERIR_NOVO_FORNECEDOR: 'inserirNovoFornecedor',
			},
			HISTORICO: {
				BUSCAR_HISTORICOS: 'buscarHistoricoAlterarFornecedor',
			},
		},

		TRANSFERENCIA: {
			TRANSFERIR: {
				BUSCAR_ESTOQUE_ORGAOS: 'buscarEstoquePorOrgaos',
				BUSCAR_ORGAOS: 'buscarOrgaosCessionarios',
				TRANSFERIR_SALDO: 'transferirSaldoDoOrgao',
			},
			HISTORICO: {
				BUSCAR_HISTORICO_TRANSFERENCIA: 'buscarHistoricoTransferencia',
			},
		},

		ALTERAR_CLASSIFICACAO: {
			ALTERAR: {
				BUSCAR_FORNECEDORES: 'alterarClassificacaoBuscarFornecedores',
				ALTERAR_CLASSIFICACAO: 'alterarClassificacao',
			},
			HISTORICO: {
				BUSCAR_HISTORICO_ALTERACAO_CLASSIFICACAO_FORNECEDORES:
					'alterarClassificacaobuscarHistoricoFornecedores',
			},
		},

		BLOQUEIO: {
			BLOQUEAR: {
				BLOQUEAR_ITENS: 'bloquearItens',
				DESBLOQUEAR_ITENS: 'desbloquearItens',
			},
			HISTORICO: {
				BUSCAR_HISTORICOS: 'buscarHistoricoBloqueio',
			},
		},
		SALVAR_INFORMACOES_PRAZO_ENTREGA: 'salvarInformacoesPrazoEntrega',
		BUSCAR_ACESSO_HISTORICO_BOTOES: 'buscarAcessoHistoricoBotoesItemAta',
	},
	FORNECEDOR_ITEM_ATA: {
		BUSCAR_FORNECEDOR_PRINCIPAL_COM_ADERENTES: 'buscarFornecedorPrincipalComAderentes',
	},
	PEDIDO: {
		BUSCAR_INFORMACOES: 'buscarInformacoesDoPedido',
		CALCULAR_TOTAL: 'calcularTotal',
		SALVAR_PEDIDO: 'salvarPedido',
		SALVAR_NUMERO_PEDIDO: 'salvarNumeroPedido',
		REMOVER_ITENS_EM_RASCUNHO: 'cancelarItensEmRascunho',
		SALVAR_ITENS_EM_RASCUNHO: 'salvarItensEmRascunho',
		EXCLUIR_PEDIDO: 'excluirPedido',
		AUTORIZAR_PEDIDO: 'autorizarPedido',
		NAO_AUTORIZAR_PEDIDO: 'naoAutorizarPedido',
		CONCLUIR_PEDIDO: 'concluirPedido',
		EFETIVAR_PEDIDO: 'efetivarPedido',
		BUSCAR_ORGAOS_DO_USUARIO: 'buscarOrgaosDoUsuarioDoPedido',
		BAIXAR_RELATORIO_PREVIO: 'baixarRelatorioPrevio',
		BUSCAR_PEDIDO_POR_FILTRO: 'buscarPedidoPorFiltro',
		BUSCAR_PEDIDO_ORGAOS: 'buscarPedidoOrgaos',
		BUSCAR_ALMOXARIFADOS: 'buscarAlmoxarifados',
		PROTOCOLO: {
			BUSCAR_ESPECIES_DOCUMENTAIS: 'buscarEspeciesDocumentaisProtocoloPedido',
			PROTOCOLAR: 'protocolarPedido',
		},
		INTEGRACAO: {
			ENVIAR: 'enviarPedidoParaIntegracao',
		},
		DOCUMENTOS: {
			ANEXO: {
				CRIAR: 'pedidoTipoAnexoCriarAnexo',
			},
			DOCUMENTO: {
				EDITOR_TEXTO: {
					ADICIONAR: 'pedidoTipoDocumentoEditorTextoAdicionar',
					REDIGIR: 'pedidoTipoDocumentoEditorTextoRedigir',
					SINCRONIZAR: 'pedidoTipoDocumentoEditorTextoSincronizar',
					VISUALIZAR: 'pedidoTipoDocumentoEditorTextoVisualizar',
					BUSCAR_POR_ID: 'pedidoBuscarDocumentoEditorTextoPorId',
				},
			},
			PROCESSO_DIGITAL: {
				JUNTAR_LOTE_DOCUMENTOS: 'pedidoDocumentosJuntarLote',
				ASSINAR_DIGITALMENTE: 'pedidoDocumentosAssinarDigitalmente',
				ASSINAR_ELETRONICAMENTE: 'pedidoDocumentosAssinarEletronicamente',
				ASSINAR_ELETRONICAMENTE_LOTE: 'pedidoDocumentosAssinarEletronicamenteLote',
				VALIDAR_DOCUMENTO_ASSINADO: 'pedidoDocumentosValidarAssinatura',
				BAIXAR_PARA_IMPRESSAO: 'pedidoBaixarParaImpressao',
				VISUALIZAR_PROCESSO_DIGITAL: 'pedidoVisualizarProcessoDigital',
				BUSCAR_DOCUMENTO_POR_ID: 'pedidoBuscarDocumentoProcessoDigitalPorId',
				CANCELAR_DOCUMENTO: 'cancelarDocumentoPedido',
				DESENTRANHAMENTO: {
					CRIAR_TERMO: 'pedidoCriarTermo',
					JUNTAR_TERMO: 'pedidoJuntarTermo',
				},
			},
			BUSCAR_POR_FILTRO: 'pedidoBuscarDocumentos',
			EXCLUIR_DOCUMENTO_OU_ANEXO: 'pedidoExcluirDocumentoOuAnexo',
			BAIXAR_DOCUMENTO_ANEXO: 'pedidoBaixarDocumentoOuAnexo',
			CONVIDAR_SIGNATARIOS: 'convidarSignatariosDocumentoPedido',
			BUSCAR_SIGNATARIOS: 'buscarSignatariosDocumentoPedido',
			BUSCAR_ASSINATURAS_NAO_CONCLUIDAS: 'buscarAssinaturasNaoConcluidasDocumentoPedido',
			BUSCAR_EMAIL_FORNECEDOR: 'buscarEmailFornecedorDocumento',
			ENVIAR_FORNECEDOR: 'enviarDocumentoOrdemUtilizacaoParaFornecedor',
			SIGNATARIOS: {
				BUSCAR_TODOS: 'buscarTodosSignatariosPedido',
				EXCLUIR: 'excluirSignatariosPedido',
			},
		},
		DOTACAO_ORCAMENTARIA: {
			BUSCAR_LISTAGEM_PAGINADA: 'pedidoDotacaoOrcamentariaBuscaLitagemPaginada',
			CRIAR_DOTACAO: 'pedidoDotacaoOrcamentariaCriarDotacao',
			EDITAR_VALOR_DOTACAO: 'editarValorDotacao',
			EXCLUIR_DOTACAO: 'excluirDotacao',
			SETUP: {
				BUSCAR_LISTAGEM_EXERCICIOS: 'BuscarListagemExercicios',
				BUSCAR_LISTAGEM_CLASSIFICACAO_DESPESAS: 'pedidoDotacaoOrcamentariaBuscarListagemClassificacaoDespesas',
				BUSCAR_LISTAGEM_ORGAOS: 'pedidoDotacaoOrcamentariaBuscarListagemOrgaos',
				BUSCAR_LISTAGEM_PAGINADA: 'pedidoDotacaoOrcamentariaBuscarListagemPaginada',
			},
		},
		REVISOES: {
			BUSCAR_DISPONIVEL: 'buscarRevisoesDisponivelPedidoUtilizacao',
			CRIAR: 'criarRevisaoPedidoUtilizacao',
		},
	},
	ITEM_PEDIDO: {
		BUSCAR_ITENS_DISPONIVEIS: 'buscarItensDisponiveisPedido',
		BUSCAR_ITENS: 'buscarItemPedido',
		SALVAR_ITEM_DISPONIVEL_QUANTIDADE: 'salvarItemPedido',
		SALVAR_ITEM_QUANTIDADE: 'salvarItemQuantidadePedido',
		ALTERAR_ELEMENTO_SUBELEMENTO_ITEM: 'alterarElementoSubElementoItemPedido',
		EXCLUIR_ITEM: 'excluirItemPedido',
		BUSCAR_ELEMENTOS_SUBELEMENTOS_ITEM: 'buscarElementosSubElementosItemPedido',
		ESTORNO: {
			ESTORNAR: {
				ESTORNAR_ITEM: 'ItemPedidoEstornoEstornar',
			},
			DETALHES: {
				BUSCAR: 'ItemPedidoEstornoBuscarHistorico',
			},
		},
	},
	ADESAO: {
		BUSCAR_ORGAOS: 'buscarOrgaosAdesao',
		CRIAR_ADESAO: 'criarAdesao',
		EDITAR_ADESAO: 'editarAdesao',
		BUSCAR_ITENS: 'buscarItensAdesao',
		BUSCAR_POR_ID: 'buscarAdesaoPorId',
		BUSCAR_LISTAGEM: 'buscarAdesoes',
		BUSCAR_TIPO_VISUALIZACAO: 'buscarTipoVisualizacao',
		DOCUMENTOS: {
			BUSCAR_PAGINADO: 'buscarDocumentosAdesaoPaginada',
			CANCELAR_DOCUMENTO: 'cancelarDocumentoAdesao',
			CONVIDAR_SIGNATARIOS: 'convidarSignatariosDocumentoAdesao',
			BUSCAR_SIGNATARIOS: 'buscarSignatariosDocumentoAdesao',
			SIGNATARIOS: {
				EXCLUIR: 'excluirSignatariosDocumentoAdesao',
			},
		},
		ITENS: {
			BUSCAR_PAGINADO: 'buscarItensAdesaoPaginada',
		},
		SALVAR_ITEM_DISPONIVEL_QUANTIDADE: 'salvarItemAdesao',
		SALVAR_ITENS: 'salvarItensAdesao',
		EXCLUIR_ITEM: 'excluirItemAdesao',
		EXCLUIR: 'excluirAdesao',
		RECUSAR: 'recusarAdesao',
		ACEITAR: 'aceitarAdesao',
		CONCLUIR: 'concluirAdesao',
		POSSUI_ITENS_PENDENTES: 'possuiItensPendentes',
		INTEGRACAO: {
			ENVIAR: 'enviarAdesaoParaIntegracao',
		},
		BUSCAR_QUANTIDADE_ADESOES: 'buscarQuantidadeAdesoes',
		BUSCAR_QUANTIDADE_FORNECEDORES_ITENS: 'buscarQuantidadeFornecedoresItens',
		BUSCAR_ADESOES_POR_ATA: 'buscarAdesoesPorAta',
		VISUALIZAR_PROCESSO_DIGITAL: 'visualizarProcessoDigitalAdesao',
		BPM: {
			BUSCAR_EXTENSIONS_TASKS: 'buscarExtensionsTasks',
		},
		BAIXAR_RELATORIO_PREVIO: 'baixarRelatorioPrevioAdesao',
		REENVIAR_ADESAO_PARA_DETALHAMENTO: 'reenviarAdesaoParaDetalhamento',
		ESTORNO: {
			ESTORNAR: {
				ESTORNAR_ITEM: 'ItemAdesaoEstornoEstornar',
			},
			HISTORICO: {
				BUSCAR: 'ItemAdesaoEstornoBuscarHistorico',
			},
		},
		REVISOES: {
			BUSCAR_DISPONIVEL: 'buscarRevisoesDisponivelAdesao',
			CRIAR: 'criarRevisaoAdesao',
		},
	},
	ORGAOS: {
		BUSCAR_ORGAOS: 'buscarOrgaos',
	},
	OCORRENCIA: {
		BUSCAR_OCORRENCIAS: 'buscarOcorrencias',
		INSERIR_OCORRENCIA: 'inserirOcorrencia',
		ENVIAR_RESPOSTA_OCORRENCIA: 'enviarRespostaOcorrencia',
		VISUALIZAR_OCORRENCIA: 'visualizarOcorrencia',
		EDITAR_RESPOSTA: 'editarRespostaOcorrencia',
		EXCLUIR_OCORRENCIA: 'excluirOcorrencia',
		EDITAR_OCORRENCIA: 'editarOcorrencia',
		ATUALIZAR_OCORRENCIA: 'atualizarOcorrencia',
	},
	PENALIDADES: {
		BUSCAR_PENALIDADES: 'buscarPenalidades',
		VALIDAR_PENALIDADES: 'validarPenalidades',
		EXCLUIR_PENALIDADE: 'excluirPenalidade',
		BUSCAR_ITENS_PENALIDADE: 'buscarItensPenalidade',
		BUSCAR_ORGAOS_SANCIONADORES_PENALIDADE: 'buscarOrgaosSancionadoresPenalidade',
		BUSCAR_FORNECEDORES_PENALIDADE: 'buscarFornecedoresPenalidade',
		BUSCAR_TIPOS_PENALIDADE: 'buscarTiposPenalidade',
		BUSCAR_DADOS_GERAIS_PENALIDADE: 'buscarDadosGeraisPenalidade',
		SALVAR_DADOS_GERAIS_PENALIDADE: 'salvarDadosGeraisPenalidade',
		ADICIONAR_ITENS_PENALIDADE: 'adicionarItensPenalidade',
		BUSCAR_ANEXOS_PENALIDADE: 'buscarAnexosPenalidade',
		NOTIFICACOES: {
			BUSCAR_NOTIFICACOES_PENALIDADE: 'buscarNotificacoesPenalidade',
			INSERIR_NOTIFICACAO_PENALIDADE: 'inserirNotificacaoPenalidade',
		},
	},
	PERMISSIONAMENTO: {
		VERIFICAR_PERMISSOES_DO_USUARIO_NO_ORGAO: 'verificarPermissoesDoUsuarioNoOrgao',
	},
	ADITIVO_APOSTILA: {
		CRIAR_ADITIVO_APOSTILA: 'criarAditivoApostila',
		BUSCAR_DADOS_GERAIS_ADITIVO_APOSTILA: 'buscarDadosGeraisAditivoApostila',
		SALVAR_DADOS_GERAIS_ADITIVO_APOSTILA: 'salvarDadosGeraisAditivoApostila',
		SALVAR_QUANTIDADE_ACRESCIMO_SUPRESSAO: 'salvarQuantidadeAcrescimoSupressao',
		CANCELAR_ACRESCIMO_SUPRESSAO: 'cancelarAcrescimoSupressao',
		EFETIVAR_ADITIVO_APOSTILA: 'efetivarAditivoApostila',
		BUSCAR_FORNECEDORES_POR_ITEM_ADITIVO_APOSTILA: 'buscarFornecedoresPorItemAditivoApostila',
		ALTERAR_FORNECEDOR_DO_ITEM_ADITIVO_APOSTILA: 'alterarFOrnecedorDoItemAditivoApostila',
		BUSCAR_HISTORICO_ADITIVO_APOSTILA: 'buscarHistoricoAditivoApostila',
		EXISTE_DOCUMENTOS_PARA_PNCP_ADITIVO_APOSTILA: 'existeDocumentosParaPncPAditivoApostila',
	},
	ITEM_ADITIVO_APOSTILA: {
		BUSCAR_ITENS_ADITIVO_APOSTILA_LISTAGEM: 'buscarItensAditivoApostilaListagem',
		BUSCAR_FORNECEDORES_ITEM_ADITIVO_APOSTILA: 'buscarFornecedoresItemAditivoApostila',
		ALTERAR_FORNECEDOR_ITEM_ADITIVO_APOSTILA: 'alterarFornecedorItemAditivoApostila',
		ALTERAR_MARCA_ITEM_ADITIVO_APOSTILA: 'alterarMarcaItemAditivoApostila',
		ALTERAR_VALOR_ITEM_ADITIVO_APOSTILA: 'alterarValorItemAditivoApostila',
		REMOVER_ITENS_ADITIVO_APOSTILA: 'removerItensAditivoApostila',
		CANCELAR_DESCANCELAR_ITENS_ADITIVO_APOSTILA: 'cancelarDescancelarItensAditivoApostila',
	},
	BPM: {
		BUSCAR_LISTAGEM_PERFIL_POR_ATIVIDADE: 'buscarListagemPerfilPorAtividade',
		BUSCAR_PROXIMAS_ATIVIDADES: 'buscarProximasAtividades',
		ENCAMINHAR_ATIVIDADE: 'encaminharAtividade',
	},
}
